import { IEnergyComparison } from "@edp-models/energy-comparison.model";

export interface IStatusMoonShot {
    started: boolean;
    completed: boolean;
    fullElectric: boolean;
    feedbackDataSubmited: string[];
    feedbackStatus?: boolean;
}

export interface IDefineHouseState {
    serviceAnswers: any[];
    answers: any[];
    energySourceSubsteps: string[];
    equipmentSubsteps: string[];
    ThermalInsulationSubsteps: string[];
    activeStepIndex: number;
    activeEquipmentStepIndex: number;
    activeThermalInsulationStepIndex: number;
    currentSubsteps: string[];
    statusMoonShot: IStatusMoonShot;
    energyComparison: IEnergyComparison,
}

export const initialDefineHouseState: IDefineHouseState = {
    serviceAnswers: null,
    answers: null,
    energySourceSubsteps: null,
    equipmentSubsteps: null,
    activeStepIndex: 0,
    activeEquipmentStepIndex: 0,
    currentSubsteps: null,
    statusMoonShot: null,
    energyComparison: null,
    activeThermalInsulationStepIndex: 0,
    ThermalInsulationSubsteps: null
};